import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import a from "../../clear/src/Clear.js";
import n from "../../icon/src/Icon.js";
import { resolveSlot as t } from "../../../_utils/vue/resolve-slot.js";
import f from "../../loading/src/Loading.js";
import s from "../../icons/ChevronDown.js";
import { defineComponent as i, h as r } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const p = i({
  name: "InternalSelectionSuffix",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    showArrow: {
      type: Boolean,
      default: void 0
    },
    showClear: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    onClear: Function
  },
  setup(e, {
    slots: l
  }) {
    return () => {
      const {
        clsPrefix: o
      } = e;
      return r(f, {
        clsPrefix: o,
        class: `${o}-base-suffix`,
        strokeWidth: 24,
        scale: 0.85,
        show: e.loading
      }, {
        default: () => e.showArrow ? r(a, {
          clsPrefix: o,
          show: e.showClear,
          onClear: e.onClear
        }, {
          placeholder: () => r(n, {
            clsPrefix: o,
            class: `${o}-base-suffix__arrow`
          }, {
            default: () => t(l.default, () => [r(s, null)])
          })
        }) : null
      });
    };
  }
});
export {
  p as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/suffix/src/Suffix.js
// module id = 894
// module chunks = 41